import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography
} from '@mui/material';
import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';
import { useStyles } from 'src/theme/vemigoCustomStyles/VemigoCustomStyles';
import { useCustomerData } from '../customerData';
import VemigoTextFeild from 'src/components/VemigoGrid/VemigoTextFeild';
import { CustomerAddresseServicess } from 'src/services/customer/addresseServices';
import { StatusSwitch } from 'src/components/VemigoGrid/VemigoStarusFeild';
import { useCustomerBookingCart } from '../selectedCustomerData';

export const AddCustomerAddress = (props) => {
  const { open, handleClose, editData, data, changedData } = props;
  const { customerAddressTypes, allCities, allAreas } = useCustomerData();
  const { setGetData, handleGetCustomerAddressById } =
    useCustomerBookingCart();

  const dataModel = {
    addressId: 0,
    name: `${data?.firstAndMiddleName} ${data?.lastName}` || '',
    addressLine1: '',
    addressLine2: '',
    contactNumber1: '',
    contactNumber2: '',
    mobileNumber: '',
    landMark: '',
    geoLocation: '',
    cityID: 0,
    areaID: 0,
    isActive: true,
    customerAddressTypeId: 0
  };

  const [newData, setNewData] = useState(dataModel);
  const [selectedAddressTypeList, setSelectedAddressTypeList] = useState([]);
  const [selectedAddressTypeId, setSelectedAddressTypeId] = useState('');
  const [selectedCityList, setSelectedCityList] = useState([]);
  const [selectedCityId, setSelectedCityId] = useState('');
  const [selectedAreaList, setSelectedAreaList] = useState([]);
  const [selectedAreaId, setSelectedAreaId] = useState('');
  const { enqueueSnackbar } = useSnackbar();
  const [isAddButtonDisabled, setIsAddButtonDisabled] = useState(true);

  const handleAddClose = () => {
    setNewData(dataModel);
    setSelectedAreaList(allAreas);
    setSelectedAreaId('');
    setSelectedCityId('');
    setIsAddButtonDisabled(true);
    setSelectedAddressTypeId('');
    props.handleClose();
  };

  useEffect(() => {
    setSelectedAddressTypeList(customerAddressTypes);
    setSelectedCityList(allCities);
    setSelectedAreaList(allAreas);
    if (changedData && !(editData && Object.keys(editData).length > 0)) {
      if (changedData.cityId) {
        setNewData({
          ...newData,
          cityID: changedData.cityId,
          areaID: changedData.areaId
        });

        setSelectedAreaList(
          allAreas.filter((x) => x.city.id === changedData.cityId)
        );
        setSelectedCityId(changedData.cityId);
        setSelectedAreaId(changedData.areaId);
      }
    }
    if (editData && Object.keys(editData).length > 0) {
      setNewData({
        ...newData,
        addressId: editData.addressId,
        addressLine1: editData.addressLine1,
        addressLine2: editData.addressLine2,
        contactNumber1: editData.contactNumber1,
        contactNumber2: editData.contactNumber2,
        mobileNumber: editData.mobileNumber,
        landMark: editData.landMark,
        geoLocation: editData.geoLocation,
        cityID: editData.cityID,
        areaID: editData.areaID,
        isActive: editData.isActive,
        customerAddressTypeId: editData.customerAddressTypeId
      });
      setSelectedAreaList(
        allAreas.filter((x) => x.city.id === editData.cityID)
      );
      setSelectedCityId(editData.cityID);
      setSelectedAreaId(editData.areaID);
      setIsAddButtonDisabled(false);
    }
  }, [open]);

  const handleDataChange = (fieldName, value) => {
    setNewData({ ...newData, [fieldName]: value });

    if (fieldName === 'cityID') {
      setSelectedAreaList(allAreas.filter((x) => x.city.id === value));
    }
    if (
      newData.addressLine1 &&
      newData.addressLine2 &&
      newData.cityID &&
      newData.areaID
    ) {
      setIsAddButtonDisabled(false);
    }
  };

  const handleAddNewData = () => {
    if (editData && Object.keys(editData).length > 0) {
      if (
        editData.addressId !== newData.addressId ||
        editData.addressLine1 !== newData.addressLine1 ||
        editData.addressLine2 !== newData.addressLine2 ||
        editData.contactNumber1 !== newData.contactNumber1 ||
        editData.contactNumber2 !== newData.contactNumber2 ||
        editData.mobileNumber !== newData.mobileNumber ||
        editData.landMark !== newData.landMark ||
        editData.geoLocation !== newData.geoLocation ||
        editData.cityID !== newData.cityID ||
        editData.areaID !== newData.areaID ||
        editData.isActive !== newData.isActive ||
        editData.customerAddressTypeId !== newData.customerAddressTypeId
      ) {
        CustomerAddresseServicess.editData(newData)
          .then((data) => {
            // setGetData(true);
            handleGetCustomerAddressById('Get');
          })
          .catch((error) => {
            console.error('Error updating data:', error);
          });
      }
    } else {
      if (
        !newData.addressLine1 ||
        !newData.addressLine2 ||
        !newData.cityID ||
        !newData.areaID
      ) {
        enqueueSnackbar('Please fill in all mandatory fields', {
          variant: 'error'
        });
        return;
      }

      const addData = {
        id: 0,
        customerId: data.id,
        customerName: newData.name,
        addresses: newData
      };
      CustomerAddresseServicess.addData(addData)
        .then((data) => {
          setGetData(true);
          handleGetCustomerAddressById('Get');
        })
        .catch((error) => {
          console.error('Error updating data:', error);
        });
    }

    handleAddClose();
  };

  const getFieldValue = (fieldId) => {
    if (fieldId.includes('.')) {
      const [parent, child] = fieldId.split('.');
      return newData[parent][child] || '';
    }
    return newData[fieldId] || '';
  };

  const india = '+91';

  const allFields = [
    {
      id: 'customerAddressTypeId',
      field: 'Select',
      title: 'Address Type*',
      type: 'Home',
      selectedId: selectedAddressTypeId,
      dataList: selectedAddressTypeList,
      function: setSelectedAddressTypeId,
      size: 6
    },
    {
      id: 'name',
      field: 'textField',
      title: 'Name*',
      type: 'text',
      size: 6
    },
    {
      id: 'addressLine1',
      field: 'textField',
      title: 'Address Line 1*',
      type: 'text',
      size: 12
    },
    {
      id: 'addressLine2',
      field: 'textField',
      title: 'Address Line 2*',
      type: 'text',
      size: 12
    },
    {
      id: 'cityID',
      field: 'Select',
      title: 'Select City*',
      type: 'City...',
      selectedId: selectedCityId,
      dataList: selectedCityList,
      function: setSelectedCityId,
      size: 6
    },
    {
      id: 'areaID',
      field: 'Select',
      title: 'Select Area*',
      type: 'Area...',
      selectedId: selectedAreaId,
      dataList: selectedAreaList,
      function: setSelectedAreaId,
      size: 6
    },
    {
      id: 'geoLocation',
      field: 'textField',
      title: 'Geo Location*',
      type: 'text',
      size: 6
    },
    {
      id: 'landMark',
      field: 'textField',
      title: 'Land Mark',
      type: 'text',
      size: 6
    },
    {
      id: 'mobileNumber',
      field: 'textField',
      title: 'Contact Number',
      type: 'text',
      size: 6,
      useFor: india,
      maxChars: 11 + india.length
    },
    {
      id: 'isActive',
      field: 'status',
      size: 12
    }
  ];

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle style={useStyles.dialogTitle}>{props.Label}</DialogTitle>
      <DialogContent style={useStyles.bodyStyle}>
        <Grid container spacing={2} style={useStyles.boxSize}>
          {allFields.map((field) => (
            <Grid item xs={field.size} key={field.id}>
              <Typography style={useStyles.formTitle}>{field.title}</Typography>
              {field.field === 'textField' && (
                <VemigoTextFeild
                  style={useStyles.formControl}
                  id={field.id}
                  type={field.type}
                  fullWidth
                  autoFocus={false}
                  useFor={field.useFor}
                  counter={false}
                  maxChars={field.maxChars}
                  value={getFieldValue(field.id) || ''}
                  onChange={(e) => handleDataChange(field.id, e.target.value)}
                  key={`textfield-${field.id}`}
                />
              )}
              {field.field === 'Select' && (
                <Select
                  displayEmpty
                  style={useStyles.formControl}
                  fullWidth
                  value={field.selectedId}
                  onChange={(e) => {
                    handleDataChange(field.id, e.target.value);
                    field.function(e.target.value);
                  }}
                >
                  <MenuItem
                    value=""
                    disabled
                    key={`${field.id}-empty-${field.type}`}
                  >
                    <em>{field.type}</em>
                  </MenuItem>
                  {field.dataList?.map((data) => (
                    <MenuItem key={data.id} value={data.id}>
                      {data.name}
                    </MenuItem>
                  ))}
                </Select>
              )}
              {field.field === 'status' && (
                <StatusSwitch
                  newData={newData}
                  handleSwitchChange={handleDataChange}
                  field={field.id}
                />
              )}
            </Grid>
          ))}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleAddClose} variant="contained">
          Cancel
        </Button>
        <Button
          onClick={handleAddNewData}
          disabled={isAddButtonDisabled}
          color="primary"
          variant="contained"
        >
          {props.addBtn}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
